<template>
  <div>
    <my-tab :tab="tab" :active="active" @tab="reTab"></my-tab>
    <ly-time @timeObj="reTimeObj"></ly-time>
    <div id="mylist" style="top: 140px">
      <div id="aedser" v-show="now == 1"></div>
      <Table v-show="now == 2" :columns="columns" :data="tableData"></Table>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import axios from "axios";
export default {
  data() {
    return {
      tab: [
        { title: "图表", mark: 1 },
        { title: "表格", mark: 2 },
      ],
      active: 0,
      now: 1,
      columns: [
        {
          title: "报警类型",
          key: "alarmTypeName",
        },
        {
          title: "次数/次",
          key: "num",
        },
        {
          title: "占比/%",
          key: "ratio",
        }
      ],
      tableData: [

      ],
      myData: [
        { value: 50, name: "急加速/50" },
        { value: 80, name: "急减速/80" },
        { value: 60, name: "急转弯/60" },
        { value: 70, name: "超速/70" },
      ],
    };
  },
  methods: {
    getData() {
      let params = {
        deviceIdList: this.deviceIdList,
        endTime: this.timeObj.end,
        startTime: this.timeObj.start,
        //pageSize: this.pageSize,
        //pageNumber: this.pageNumber,
        //alarmTypeIdList: [1,2,3,4,5,6,10,11,14,15],
        alarmTypeIdList: [],
      };
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.serverWeb + "/alarmInfo/analysis",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList.filter(function (item) {
          return item.alarmTypeName.indexOf('离线')==-1;
        });
        
        this.tableData=data;
        this.myData=[];

        for (const i in data) {
          var obj={
            value:data[i].num,
            name:data[i].alarmTypeName
          };
          this.myData.push(obj);
        }
        this.drawBar();
      });
    },
    drawBar() {
      var that = this;
      this.chart = echarts.init(document.getElementById("aedser"));
      this.option = {
        //backgroundColor: "",
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b}: {c} ({d}%)"
          formatter: "{b}: {c}次 ({d}%)",
        },

        series: [
          {
            name: "",
            type: "pie",
            radius: ["0%", "50%"],
            //avoidLabelOverlap: false,
            /* label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: true,
            }, */
            data: this.myData,
          },
        ],
        color: [
          "#5e7aff",
          /* "#15c2b8", */
          "#ef3cf6",
          "#1bc85e",
          "#e8d611",
        ],
      };

      this.chart.setOption(this.option);

      this.chart.resize();
    },
    reTab(v) {
      this.now = v.mark;
      if (this.now == 1) {
        setTimeout(() => {
          this.drawBar();
        }, 500);
      }
    },
    reTimeObj(v) {
      this.timeObj = v;
      this.getData();
    },
  },
  mounted() {
    // this.drawBar()
  },
};
</script>
<style lang="">
#aedser {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/fenxi/baojing/month.vue